module.exports = __webpack_public_path__ + "img/5.d6bfefa7.png";